import { Accordion, Form, Tab, Tabs } from "react-bootstrap";
import { TopBar } from "../shared/topBar/TopBar";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { UrlPath } from "../../config/routeConfig";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { Pricing } from "../Portfolio/Pricing";
import { AssetAUMList } from "../Portfolio/AssetAum";
import { useLocation, useParams } from "react-router-dom";

export const Valuation = () => {
    const params=useParams();
    const [initializer ,setInitializer ]=useState("");
    useEffect(() => {
        document.title = `Pricing`;
    }, [])
    useEffect(() => {
        const url = window.location.pathname;
        const firstModule = url.split('/').filter(Boolean)[0];  
        if(firstModule.trim()=="Portfolio")
        setInitializer("Portfolio");
        else 
        setInitializer("Asset");
    }, [window.location.pathname]);
    const Level = [{ BreadCrumb: initializer+" >", Routes: initializer=="Portfolio" ? `/${UrlPath.PortfolioList}` : `${UrlPath.Asset}` },{ BreadCrumb: "Valuations"}]
    return <>
        <TopBar label={initializer+" Valuations"} />
        <div id="PricingList" className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="asset-detail-screen p-3">
                <Tabs id="uncontrolled-tab-example" className="ms-3 borderbtm0">
                    <Tab eventKey="Pricing" title="Pricing"  >
                    <div className="p-3 bg-white life-science rounded">
                        <Pricing/>
                    </div>                        
                    </Tab>
                    <Tab eventKey="AssetAum" title="Asset AUM" >
                    <div className="p-3 bg-white life-science rounded">
                        <AssetAUMList/>
                    </div>
                        
                    </Tab>
                </Tabs>
            </div>
        </div>
        <ToastContainer />
    </>
};
